import React from "react";

const TestimonialsSection = () => {
  return (
    <section id="testimonials-section" className="section testimonials-section" aria-label="Customer reviews from Google">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label" style={{ color: "rgba(255,255,255,0.7)" }}>
            Customer Reviews
          </div>
          <h2 className="section-title" style={{ color: "white" }}>
            What Our Customers Say
          </h2>
          <p className="section-subtitle" style={{ color: "rgba(255,255,255,0.6)" }}>
            Rated 4.8★ on Google — hear from real customers who trust Mauli Services for TV & washing machine repair in Pune.
          </p>
        </div>

        {/* Google Rating Badge */}
        <div style={{ textAlign: "center", marginBottom: "var(--space-2xl)" }}>
          <div className="google-rating-badge">
            <div className="google-rating-left">
              <span className="google-g-logo">
                <span style={{color:"#4285F4"}}>G</span>
                <span style={{color:"#EA4335"}}>o</span>
                <span style={{color:"#FBBC05"}}>o</span>
                <span style={{color:"#4285F4"}}>g</span>
                <span style={{color:"#34A853"}}>l</span>
                <span style={{color:"#EA4335"}}>e</span>
              </span>
              <span className="google-rating-text">Reviews</span>
            </div>
            <div className="google-rating-right">
              <span className="google-rating-number">4.8</span>
              <span className="google-rating-stars">★★★★★</span>
              <span className="google-rating-count">(34)</span>
            </div>
            <a
              href="https://www.google.com/search?q=mauli+services&rlz=1C1RXQR_enIN997IN997&oq=mauli+services&gs_lcrp=EgZjaHJvbWUqDggAEEUYJxg7GIAEGIoFMg4IABBFGCcYOxiABBiKBTIICAEQABgWGB4yCAgCEAAYFhgeMggIAxAAGBYYHjIICAQQABgWGB4yBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQkxMTAwNGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8&lqi=Cg5tYXVsaSBzZXJ2aWNlc0jR6oSt3bqAgAhaGBAAEAEYABgBIg5tYXVsaSBzZXJ2aWNlc5IBD2F0dl9yZXBhaXJfc2hvcA#rlimm=11931023109066211457&lrd=0x3bc2c70064b704fd:0xa593824deede4081,3,,,,"
              target="_blank"
              rel="noopener noreferrer"
              className="google-review-btn"
            >
              Review us on Google
            </a>
          </div>
        </div>

        {/* Elfsight Google Reviews Widget */}
        <div className="elfsight-reviews-container">
          <div className="elfsight-app-d1ae0d0d-6deb-4bc2-b31a-ed1933d5fa5f" data-elfsight-app-lazy></div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
